/** @format */
import React, { useContext } from 'react';

import {
    ApplicationContext,
    ModalOptions,
    ModalSize,
} from '@toucan/client/global/application';

import { FullBasketErrorModalContent } from '@toucan/client/core/basket/components/full-basket-error-modal-content';

export function useBasketMaxItemsError() {
    const { setModalVisible, setModalContent } = useContext(ApplicationContext);

    const showBasketMaxItemsError = ({
        isClosable,
        basketMaxItems = 0,
    }: Pick<ModalOptions, 'isClosable'> & { basketMaxItems?: number } = {}) => {
        if (basketMaxItems === 0) return;

        setModalContent(
            <FullBasketErrorModalContent maxItems={basketMaxItems} />
        );
        setModalVisible(true, { size: ModalSize.MEDIUM, isClosable });
    };

    const hideBasketMaxItemsError = () => {
        setModalVisible(false);
    };

    return {
        showBasketMaxItemsError,
        hideBasketMaxItemsError,
    };
}
